import { Component, OnInit} from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-bulk-operation',
  templateUrl: './bulk-operation.component.html',
  styleUrls: ['./bulk-operation.component.scss']
})
export class BulkOperationComponent implements OnInit {


  rows =[
    {name:'HRM'},
    {name:'CRM'},
    {name:'Job'},
    {name:'Training'},
    {name:'Utility'},
    {name:'Tools'},
  ]
  public empTypeView: boolean[] = [];
  statusList =[]

  guideline_data: any


  constructor(public apiService: ApiService,private modalService: NgbModal,
              public toastr: ToastrService,) {
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Bulk Operations') 
    this.guideline_data = key_data[0]?._id
   }

  ngOnInit(): void {
    this.getLeadsStatusList()
  }
  getLeadsStatusList() {
    this.apiService.getLeadsStatusList("leadstatus").subscribe((res: any) => {
      this.statusList = res.data
    })
  }
  deleteOutsourceLeadByCloseStatus(){
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.apiService.getOutSourceLeadsDeleteCloseStatus(result.value).subscribe((res:any)=>{
          if(res.statusCode === 200){
            swal.fire({
              icon: "success",
              title: 'Delete!',
              text: `${res.total} leads deleted successfully.`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            
          }
          else {
            swal.fire({
              icon: "error",
              title: 'Move!',
              text: `${res.error}`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        })

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  currentStatusToClose(prop){
    let training_type_id = '63e39db72052e0098e18e00e'
    let outsource_type_id = '63e39dd62052e0098e18e015'

    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to Close this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
       
            if(prop === 'training-leads'){
              let current_status = this.statusList.filter(item=>item.name =='open')
              this.apiService.getLeadsMoveToCloseStatus(training_type_id,current_status[0]._id,'63e3971b2052e0098e18defa').subscribe((res: any) => {
                if (res.statusCode === 200) {
                  swal.fire({
                    icon: "success",
                    title: 'Move!',
                    text: `${res.data.leads.n} Move to close status Successfully.`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                }
                else {
                  swal.fire({
                    icon: "error",
                    title: 'Move!',
                    text: `${res.error}`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                }
              })
            }
            if(prop === 'outsource-leads'){
              let current_status = this.statusList.filter(item=>item.name =='open')
              this.apiService.getLeadsMoveToCloseStatus(outsource_type_id,current_status[0]._id,'63e3971b2052e0098e18defa').subscribe((res: any) => {
                if (res.statusCode === 200) {
                  swal.fire({
                    icon: "success",
                    title: 'Move!',
                    text: `${res.data.leads.n} Move to close status Successfully.`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                  
                }
                else {
                  swal.fire({
                    icon: "error",
                    title: 'Move!',
                    text: `${res.error}`,
                    customClass: {
                      confirmButton: 'btn btn-success'
                    },
                  })
                }
              })
            }

      }
    });
  }
 
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }

  addBulkChecklist(password){
    if(password === "S@nd33p"){
      let body = {
        //  staging checklist & sprint Ids
        // checklist: '6545db054ae8739ffc6f922a' ,
        // sprint: '6545db054ae8739ffc6f922c',

        //  production checklist & sprint Ids
        checklist: '6545195d15950cbce9ddc5ad' ,
        sprint: '6545195d15950cbce9ddc5af',
      }
      this.apiService.addBulkSprint(body).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          swal.fire({
            title: "Success!",
            text: `The new checklist added in ${res?.data?.count}. ${res?.message}`,
            icon: "success",
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false,
          });
        }
        else this.toastr.error(res?.error)
      })
    }
    else this.toastr.error('Invalid password!')
   
  }
   // ================== Delete Alert ========================
   alertToAddBulkChecklist() {
    
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.addBulkChecklist(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  confirmDelete(){
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteOutsourceLeads(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  deleteOutsourceLeads(password){
    this.apiService.deleteOldOutsourceLeads(password).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        swal.fire({
          title: "Success!",
          text: `${res?.message}`,
          icon: "success",
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false,
        });
      }
      else swal.fire({
        title: 'Error',
        text: `${res?.error}`,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    })
  }
  deleteOldEmployee(password){
    this.apiService.deleteOldEmployee(password).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        swal.fire({
          title: "Success!",
          text: `${res?.message}`,
          icon: "success",
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false,
        });
      }
      else swal.fire({
        title: 'Error',
        text: `${res?.error}`,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    })
  }
  confirmDeleteEmp(){
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteOldEmployee(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  confirmDeleteTraining(){
    this.apiService.deleteOldTrainingLead().subscribe((res:any)=>{
      if(res?.statusCode === 200){
        swal.fire({
          title: "Success!",
          text: `${res?.message}`,
          icon: "success",
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false,
        });
      }
      else swal.fire({
        title: 'Error',
        text: `${res?.error}`,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    })
  }
  deleteDump(fromDate,toDate,password) {
    this.apiService.deleteAllDumpData(fromDate, toDate, password).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Delete All Dump Data')
      }
      else this.toastr.error(res.error)
    })
  }
  
  confirmDeleteDump() {
  swal.fire({
    title: 'Are you sure to Delete Dump Data?',
    html: `
      <div class="position-relative">
        <label class="position-absolute">From Date</label>
        <input type="date" id="fromDate" class="swal2-input" placeholder="From Date">
      </div>
      <div class="position-relative">
        <label class="position-absolute">End Date</label>
        <input type="date" id="endDate" class="swal2-input" placeholder="End Date">
      </div>
      <div class="position-relative">
        <label class="position-absolute">Password</label>
        <input type="password" id="password" class="swal2-input" placeholder="Enter Password">
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
  }).then((result) => {
    if (result.value) {
      const fromDate = (document.getElementById('fromDate') as HTMLInputElement).value;
      const endDate = (document.getElementById('endDate') as HTMLInputElement).value;
      const password = (document.getElementById('password') as HTMLInputElement).value;   
      if (!fromDate || !endDate || !password) { 
        this.toastr.error('Please fill all fields')
      }
      if (fromDate > endDate ) { 
        this.toastr.error('From date should be less than end date!')
      }
      if (endDate < fromDate ) { 
        this.toastr.error('End date should not be less than from date!')
      }

      if (fromDate && endDate && password) {
        this.deleteDump(fromDate,endDate,password)
      }

      // Handle deletion logic here using the retrieved values
    } else if (result.dismiss === swal.DismissReason.cancel) {
      swal.fire({
        title: 'Cancelled',
        text: 'Your file is safe :)',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      });
    }
  });

  
}

}

